import { enumSCDensity } from "../constants";
import { CompareArrayByScore } from "../utils/CompareArrayByScore";
import { Globals } from "./Globals";
import { TreeNode } from "./TreeNode";

export class TreeGraph {
  constructor() {
    this.fRootNode = null;
  }

  InitGraph(obj, pageDensity) {
    if (pageDensity === enumSCDensity.standard) {
      Globals._targetScore = 20;
    }

    if (pageDensity === enumSCDensity.dense) {
      Globals._targetScore = 30;
    }

    if (pageDensity === enumSCDensity.verydense) {
      Globals._targetScore = 80;
    }

    var targetScore = Globals._targetScore;

    var keepCandidateSize = 20;
    this.fRootNode = new TreeNode();

    this.fRootNode.InitNode(obj, null, true);

    var candidates = this.DetachBasedOnTargetScore(this.fRootNode, targetScore);
    var approvedCandidates = [];
    var secondaryCandidates = [];

    while (candidates.length > 0) {
      var nCandidates = candidates.length;
      secondaryCandidates.length = 0;
      secondaryCandidates = candidates.slice();
      for (var i = 0; i < nCandidates; i++) {
        var candidate = candidates.shift();
        var bigNode = candidate[0];
        if (bigNode.fScore > targetScore) {
          var newCandidates = this.DetachBasedOnTargetScore(bigNode, targetScore);
          if (newCandidates.length === 1 && newCandidates[0].length === 1) {
            approvedCandidates.push(candidate);
          } else {
            // now add copy of rest of big node to all this additional candidates and add it to candidates
            for (var j = 0; j < newCandidates.length; j++) {
              var additionalCandidate = this.CloneArray(newCandidates[j], 0);
              if (candidate.length > 1) {
                additionalCandidate = additionalCandidate.concat(this.CloneArray(candidate, 1));
              }
              candidates.push(additionalCandidate);
            }
          }
        } else {
          approvedCandidates.push(candidate);
        }
      }

      // now check the candidates list, if the size is getting too big, remove largest items (ie. items that
      // still their big node has large scores.
      if (candidates.length > keepCandidateSize) {
        candidates.sort(CompareArrayByScore);
        candidates.splice(0, candidates.length - keepCandidateSize);
      }
    }

    if (approvedCandidates.length === 0) {
      approvedCandidates = secondaryCandidates.slice();
    }
    // find best candidate

    nCandidates = approvedCandidates.length;
    if (nCandidates > 0) {
      this.PruneAndSortArray(approvedCandidates, targetScore);
      // for now, let's assume first one is good.
      return approvedCandidates[0];
    }
  }

  // returns a deep copy of array from input start to end of array
  CloneArray(nodeArray, start) {
    var copyArray = [];
    for (var i = start; i < nodeArray.length; i++) {
      var node = nodeArray[i].Clone();
      copyArray.push(node);
    }

    return copyArray;
  }

  // breaks somewhere down the grandchildren of node based on closest
  // score of sub-nodes.
  // It returns an array of broken nodeArrays bosed on this score.
  // It will never return an empty array. If node's score is already less than desired score, it returns an array one one
  // whose element is just the node.
  DetachBasedOnTargetScore(node, desiredScore) {
    var candidates = [];
    var candidate = [];
    if (node.fScore < desiredScore) {
      candidate.push(node.Clone());
      candidates.push(candidate);
      return candidates;
    }

    var nodeArray = node.GetCandidateNodes(desiredScore, 2);
    if (nodeArray.length === 0) {
      candidate.push(node.Clone());
      candidates.push(candidate);
      return candidates;
    }

    // Clone before mutating — BreakAway must not alter the original tree
    var nodeCopy = node.Clone();
    // Re-get candidates from the clone so nodeBreak references are within the clone
    nodeArray = nodeCopy.GetCandidateNodes(desiredScore, 2);
    if (nodeArray.length === 0) {
      candidate.push(nodeCopy);
      candidates.push(candidate);
      return candidates;
    }

    var nodeBreak = nodeArray[0];
    if (nodeBreak.fParent !== null) {
      nodeCopy.BreakAway(nodeBreak);
      nodeBreak.fParent = null;
      candidate = new Array();
      candidate.push(nodeCopy);
      candidate.push(nodeBreak);
    } else {
      candidate = new Array();
      candidate.push(nodeCopy);
    }
    candidates.push(candidate);
    return candidates;
  }

  PruneAndSortArray(candidates, maxScore) {
    for (var i = candidates.length - 1; i >= 0; i--) {
      var nodeArray = candidates[i];
      if (!this.isFitAll(nodeArray, maxScore) && candidates.length > 1) {
        candidates.splice(i, 1);
      }
    }
  }

  LogNodeArray(nodeArray) {
    var logMsg = "";
    var n = nodeArray.length;
    for (var i = 0; i < n; i++) {
      var node = nodeArray[i];
      logMsg += "[" + node.fScore + "] ";
    }
    console.log(logMsg);
  }

  isFitAll(nodeArray, maxScore) {
    var doesFit = true;
    for (var i = 0; i < nodeArray.length; i++) {
      if (nodeArray[i].fScore > maxScore) {
        doesFit = false;
        break;
      }
    }

    return doesFit;
  }
}
